import React from 'react'
import Audit from '../../../../../containers/Audits'
import Grid from "@material-ui/core/Grid";

const ClaimAudit = (props) => {
  return (
    <div>  
        <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <Audit entity_guid={props.claimGuid} />
            </Grid>
          </Grid>
    </div>
  )
}

export default ClaimAudit